export enum DialogTypes {
  changeEmail= "changeEmailModal",
  changeAddress= "changeAddressModal",
  changePassword= "changePasswordModal",
};
